/**
 * TMF9 React Application Entry Point
 *
 * Ponto de entrada da aplicacao React.
 * Configura providers globais: QueryClient, Router, Theme.
 *
 * @since 2025-12-15
 * @module tmf_core
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Global configurations (must be imported early)
import './config/chartjs'; // Chart.js registration

// Initialize CDN store (load CDN URL from backend)
import { useCdnStore } from './store/cdnStore';
useCdnStore.getState().loadFromBackend();

// Styles
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
